import {findCtlsByKey, findCtlsByType, IKeyMap} from "@/main-page/utils/findCtlEUtils";
import {replaceEventCharMap} from "@/main-page/tempUseUtils/utils/com";
import {getUrlParams} from "xmgoing-utils";

/**
 * 事件编排信息处理
 * @param mainTable
 * @param eventId
 */
const eventItemDbListDeal = (mainTable,eventId) => {
  const keyChangMap: Array<IKeyMap> = [];
  keyChangMap.push({oldKey: "#{tableCode}", newKey: mainTable.tableCode});
  keyChangMap.push({oldKey: "#{pageCode}", newKey: (getUrlParams('pageCode',true)+'')});
  replaceEventCharMap({id:eventId,keyChangMap});
}

/**
 * 事件字符串处理
 * @param str
 * @param mainTable
 * @param eventId
 */
const eventItemJsContentDeal=function (str,mainTable,eventId){
  str = str.replace(/#\{tableCode\}/g, mainTable.tableCode);
  eventItemDbListDeal(mainTable,eventId);
  return str;
}

/**
 * 初始化提交按钮对事件信息
 * @param infoSettingJsonObj
 * @param mainTable
 * @param versionItem
 * @param backFun
 * @param changeObj
 */
const initSubmitBtn=function (infoSettingJsonObj,{mainTable,versionItem,backFun,changeObj}){
  const targetObj: any = {targetList: []};
  //表格区域初始化
  findCtlsByType(unref(infoSettingJsonObj).blocks, "xmButton", targetObj);
  if (targetObj && targetObj.targetList.length > 0) {
    targetObj.targetList.forEach((btnItem)=>{
      btnItem.events.forEach((eventItem)=>{
        if(eventItem&&eventItem.jsContent&&(eventItem.jsContent+'').indexOf("#{tableCode}")>=0){
          changeObj.changeFlag=true;
          eventItem.jsContent = eventItemJsContentDeal(eventItem.jsContent,mainTable,eventItem.eventId);
          console.log(eventItem.jsContent,"=======eventItem.jsContent")
        }
      })
    })
  }
}

const initFormCtl = (infoSettingJsonObj,{mainTable,versionItem,backFun,changeObj}) => {
  const targetObj: any = {targetList: []};
  //表格区域初始化
  findCtlsByType(unref(infoSettingJsonObj).blocks, "xmForm", targetObj);
  if (targetObj && targetObj.targetList.length > 0) {
    const findObj = targetObj.targetList[0];
    if (findObj&&findObj.dataConfig&&(findObj.dataConfig.url==null||findObj.dataConfig.url==='')) {
      // const {tableCode,tableCaption}=mainTable;
      // findObj.dataConfig={
      //   "dataFormType": "dynamic",
      //   "dataSubFormType": "userDef",
      //   "autoLoadData": true,
      //   "orderFieldList": [],
      //   "columns": [],
      //   "dateQueryType": "queryData",
      //   "hasVuexDef": true,
      //   "url": "/api/go-lcc/execute/pageByTableCode/"+tableCode,
      //   "selId": "",
      //   "templateContentLabel": "",
      //   "templateContent": "",
      //   "waitSelCols": [],
      //   "readColList": [],
      //   "domainCode": tableCode,
      //   "moduleName": tableCaption,
      //   "moduleId": "1800085656835510274",
      //   "pageSize": 999999,
      //   "xPointId": []
      // }
    }
  }
}

/**
 * 普通表单 保存 进行模版处理
 * @param pageConfigs
 * @param mainTable
 * @param versionItem
 * @param backFun
 */
const commonFormDes = function ({pageConfigs,mainTable,versionItem, backFun}) {
  const changeObj={changeFlag:false};
  initSubmitBtn(pageConfigs,{mainTable,versionItem,backFun,changeObj});
  initFormCtl(pageConfigs,{mainTable,versionItem,backFun,changeObj});
  return changeObj.changeFlag;
}


/**
 * 解析表单设计 JSON 字符串，提取第一个 xmForm 控件配置（含容错）
 *
 * 流程：JSON.parse 表单设计字符串 → 在其 blocks 树中查找 componentKey 为 xmForm 的控件 → 返回首个匹配项
 * 字符串为空、JSON 非法或未找到 xmForm 时返回 null，调用方无需自行处理异常
 *
 * @param formDesJsonStr 表单设计 JSON 字符串（infoSettingJson）
 * @returns 首个 xmForm 控件配置；无效输入或未找到时返回 null
 */
export const getFormDesByJsonStr = (formDesJsonStr: string | undefined | null): any => {
  if (!formDesJsonStr) return null
  try {
    const formDesJsonObj = typeof formDesJsonStr==='string'?JSON.parse(formDesJsonStr):formDesJsonStr;
    const targetObj: any = {targetList: []}
    findCtlsByType(formDesJsonObj?.blocks, 'xmForm', targetObj)
    return targetObj.targetList[0] || null
  } catch {
    return null
  }
}
/**
 * 根据key获取表单对象信息
 * @param formDesJsonStr
 * @param formKey
 */
export const getFormDesByJsonStrByFormKey = (formDesJsonStr: string | undefined | null,formKey:string): any => {
  debugger
  if (!formDesJsonStr) return null
  try {
    const formDesJsonObj = typeof formDesJsonStr==='string'?JSON.parse(formDesJsonStr):formDesJsonStr;
    const targetObj: any = {targetList: []}
    findCtlsByKey(formDesJsonObj?.blocks, formKey, targetObj);
    return targetObj.targetList[0] || null
  } catch {
    return null
  }
}


export default commonFormDes;
